import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { IconDefinition, library } from '@fortawesome/fontawesome-svg-core'
import {
  faSparkles,
  faCaretDown,
  faCircleXmark,
  faCircleCheck,
  faTriangleExclamation,
  faXmark,
  faMinus,
  faPlus,
  faCircleInfo as fasCircleInfo,
  faHighlighter,
  faSpinnerThird,
  faPenToSquare,
  faPaintBrush,
  faChevronRight,
  faChevronLeft,
  faCircleExclamation,
  faStar as fasStar,
  faBolt,
  faArrowUpFromBracket,
  faList,
  faArrowLeftFromLine,
  faRightToBracket,
  faBookmark as fasBookmark,
  faWandMagicSparkles,
  faPeopleArrows,
  faLockKeyhole as fasLockKeyhole,
  faEllipsis,
  faBars,
  faHouse,
  faSquareKanban as fasSquareKanban,
  faFilePen as fasFilePen,
  faBan,
  faUser,
  faArrowUpArrowDown,
  faArrowLeftToLine,
  faArrowRightFromLine,
  faArrowUp,
  faArrowDown,
  faBold,
  faItalic,
  faUnderline,
  faH1,
  faH2,
  faP,
  faTextSlash,
  faSlidersSimple,
  faLightbulb,
} from '@fortawesome/pro-solid-svg-icons'

import {
  faCopy,
  faCircleInfo,
  faFlagSwallowtail,
  faSquareKanban,
  faArrowDownToLine,
  faStar,
  faMessagesQuestion,
  faFileLines,
  faCircleCheck as faCircleCheckRegular,
  faBolt as faBoltRegular,
  faArrowsRepeat,
  faArrowRight,
  faEnvelopeOpenText,
  faBriefcase,
  faFileChartPie,
  faPencil,
  faPalette,
  faClockRotateLeft,
  faRotateRight,
  faPenToSquare as farPenToSquare,
  faFilePen,
  faCircleCheck as farCircleCheck,
  faFloppyDisk,
  faTrashCanXmark,
  faBarsFilter,
  faMagnifyingGlass,
  faLocationDot,
  faChevronDown,
  faArrowUpRightFromSquare,
  faMoneyBillWave,
  faBookmark,
  faTrashCan as farTrashCan,
  faBoxArchive,
  faContactCard,
  faFileMagnifyingGlass,
  faCheck,
  faGripDotsVertical,
  faUserSecret,
  faEye,
  faEyeSlash,
  faPen,
  faCircleQuestion,
  faCircleMinus,
  faBallotCheck,
  faPrint,
  faCog,
  faContactBook,
  faBell,
  faGem,
  faCalendarDay as faCalendarDayRegular,
  faLinkSimple,
  faClipboard,
  faClone,
  faRotateLeft,
  faBarcodeRead,
  faFiles,
  faHouse as farHouse,
  faXmark as farXmark,
  faMegaphone,
  faCloudArrowUp,
  faCloudCheck,
  faCloudXmark,
  faFilter as filterIcon,
  faUserPlus,
  faUserHeadset,
  faBadgeCheck,
  faArrowLeft,
  faArrowRotateLeft,
  faArrowRotateRight,
  faTableColumns,
  faLock,
  faArrowTrendUp,
} from '@fortawesome/pro-regular-svg-icons'

import { faCalendarDay } from '@fortawesome/pro-duotone-svg-icons'

import {
  faSpinnerThird as falSpinnerThird,
  faClone as falClone,
} from '@fortawesome/pro-light-svg-icons'

import {
  faLinkedin,
  faFacebook,
  faXTwitter,
  faChrome,
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faCopy,
  faSparkles,
  faCircleInfo,
  fasCircleInfo,
  faCaretDown,
  faFlagSwallowtail,
  faCircleXmark,
  faXmark,
  farXmark,
  faSquareKanban,
  fasSquareKanban,
  faArrowDownToLine,
  faStar,
  fasStar,
  faCircleCheck,
  faTriangleExclamation,
  faMinus,
  faPlus,
  faMessagesQuestion,
  faHighlighter,
  faSpinnerThird,
  faPenToSquare,
  faPaintBrush,
  faChevronRight,
  faChevronLeft,
  faCircleExclamation,
  faBolt,
  faArrowUpFromBracket,
  faFileLines,
  faCircleCheckRegular,
  faBoltRegular,
  faArrowsRepeat,
  faArrowRight,
  faEnvelopeOpenText,
  faBriefcase,
  faFileChartPie,
  faPencil,
  faPalette,
  faClockRotateLeft,
  faRotateRight,
  farPenToSquare,
  faList,
  falSpinnerThird,
  faFilePen,
  fasFilePen,
  farCircleCheck,
  faFloppyDisk,
  faTrashCanXmark,
  farTrashCan,
  faBarsFilter,
  faMagnifyingGlass,
  faLocationDot,
  faChevronDown,
  faEllipsis,
  faArrowUpRightFromSquare,
  faMoneyBillWave,
  faBookmark,
  faArrowLeftFromLine,
  faBoxArchive,
  fasBookmark,
  faRightToBracket,
  faClone,
  faContactCard,
  faWandMagicSparkles,
  faFileMagnifyingGlass,
  faCheck,
  faGripDotsVertical,
  faPeopleArrows,
  faUserSecret,
  fasLockKeyhole,
  faEye,
  faEyeSlash,
  faPen,
  faCircleQuestion,
  faCircleMinus,
  faLinkedin as IconDefinition,
  faBallotCheck,
  faPrint,
  faBars,
  faHouse,
  faCalendarDay,
  faCog,
  faContactBook,
  faBell,
  faBan,
  faGem,
  faCalendarDay,
  faCalendarDayRegular,
  faLinkSimple,
  falClone,
  faArrowUpArrowDown,
  faRotateLeft,
  faClipboard,
  falClone,
  faBarcodeRead,
  faBell,
  faFacebook,
  faXTwitter,
  faFiles,
  farHouse,
  faUser,
  faArrowLeftToLine,
  faMegaphone,
  faArrowRightFromLine,
  faChrome,
  faCloudArrowUp,
  faCloudCheck,
  faCloudXmark,
  faUserPlus,
  faUserHeadset,
  filterIcon,
  faArrowUp,
  faArrowDown,
  faBold,
  faItalic,
  faUnderline,
  faH1,
  faH2,
  faP,
  faTextSlash,
  faSlidersSimple,
  faLightbulb,
  faBadgeCheck,
  faArrowLeft,
  faArrowRotateLeft,
  faArrowRotateRight,
  faTableColumns,
  faLock,
  faArrowTrendUp,
)

export default FontAwesomeIcon
